<template>
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/search-vouchers">Search</router-link> |
    <router-link to="/vouchers">Vouchers</router-link> |
    <router-link to="/not-found">NoVouchers</router-link> |
    <router-link to="/payment-status">PaymentStatus</router-link> |
    <router-link to="/payment-status?id=1000">PaymentSuccess</router-link> |
    <router-link to="/not-found">NotFound</router-link> |
    <router-link to="/error">Error</router-link>
  </div>
  <div class="bg-gray">TEST</div> -->
  <div class="flex-col-grow">
    <router-view />
  </div>
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

// #nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       @apply text-xl;
//     }
//   }
// }
</style>
